// extracted by mini-css-extract-plugin
export var actions = "_7d-8";
export var arrow = "_7d-5";
export var card = "_7d-0";
export var cardWrapper = "_7d-9";
export var fieldName = "_7d-3";
export var newValue = "_7d-6";
export var oldValue = "_7d-4";
export var orangeGlowFade = "_7d-c";
export var productSection = "_7d-1";
export var scrollToBottom = "_7d-b";
export var scrollToBottomAnchor = "_7d-a";
export var scrollToBottomIcon = "_7d-d";
export var showAllButton = "_7d-7";
export var table = "_7d-2";